import React, { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import api from "../../../services/api";
import { ChartsBar } from "../../../components/Charts";
import { Col, Row, Form, Table } from "react-bootstrap";
import DatePicker from "../../../components/DatePicker";
import Slct from "../../../components/Slct";
import tableStyle from "../../../components/Table/Table.module.css";
import getCommercial from "../../../util/getCommercial";
import { PrintPage } from "../../../components/PrintPage";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import { formatReal, formatPhone, formatDate, statusPaymentSlips } from "../../../util/functions";
import StatusFlag from "../../../components/StatusFlag";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Area, ComposedChart } from "recharts";

const data = [];
const anos = [25, 26, 27, 28, 29];
const meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

// Valores base para simulação
const baseEsperado = 60000;
const baseVigente = 1000;
let baseRecebido = 1000;

anos.forEach((ano, anoIdx) => {
  meses.forEach((mes, mesIdx) => {
    baseRecebido += Math.random() * 1000;
    data.push({
      name: `${mes}/${ano}`,
      "Total Esperado": baseEsperado,
      "Total Vigente": baseVigente + (mesIdx + anoIdx * 12) * 1000,
      "Total Recebido": baseRecebido,
    });
  });
});

export default function ReportsFinancial() {
  const { setbreadcrumb, me, config } = useWrapper();

  const [filter, setFilter] = useState({
    Tipo: "Geral",
    Filtro: "dataVencimento",
    Turma: null,
    Status: null,
    Formando: null,
    "Data Inicial": null,
    "Data Final": null,
  });
  const [totalPayments, setTotalPayments] = useState({
    pagar: 0,
    pago: 0,
    juros: 0,
  });

  const [reports, setReports] = useState({
    data: [],
    title: "",
    type: "",
  });

  const [filterLoading, setfilterLoading] = useState(true);

  const [groups, setgroups] = useState();
  useEffect(() => {
    getCommercial(null, null, "?is_class=1", "", true).then(resp => {
      setgroups(
        [
          {
            label: "-- Todas --",
            value: null,
          },
        ].concat(resp.filter(e => e.status === "Ativa")),
      );
    });
  }, []);

  const [trainees, settrainees] = useState();
  const [payments, setpayments] = useState();
  useEffect(() => {
    setfilterLoading(true);
    if (filter["Tipo"] === "Inadimplência") {
      api.get(`/commercial/inadimplencia-for-class/report/${filter["Turma"].value}`, config).then(_trainees => {
        settrainees(_trainees.data);
      });
    } else if (filter["Tipo"] === "Turma") {
      let status = "";
      let atrasado = "";
      var d = new Date();

      var datestring = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      if (filter["Status"] == "nao-gerado") {
        status = "&status=nao-gerado";
      } else if (filter["Status"] == "pago") {
        status = "&status=pago";
      } else if (filter["Status"] == "Geral") {
        status = "&status=gerado";
      } else if (filter["Status"] == "cancelado") {
        status = `&status="cancelado"`;
      } else {
        status = `&status=!cancelado`;
      }

      if (filter["Status"] == "atrasado") {
        atrasado = `&dueInterval=null%7C${datestring}&status=pago%2Cnao-gerado%2Ccancelado`;
      } else {
        atrasado = "";
      }

      api
        .get(`/paymentslips?commercial_id=${filter["Turma"].value}&paginate=false${status}${atrasado}`, config)
        .then(_payments => {
          const total = _payments.data.reduce(
            (acc, curr) => {
              acc.value += curr.value;
              acc.value_paid += curr.value_paid;
              acc.value_juros += curr.value_juros;
              return acc;
            },
            { value: 0, value_paid: 0, value_juros: 0 },
          );

          setpayments(_payments.data);

          setTotalPayments({
            pagar: total.value,
            pago: total.value_paid,
            juros: total.value_juros,
          });
        });
    }
    setfilterLoading(false);
  }, [filter["Turma"], filter["Status"]]);

  useEffect(() => {
    const PARAMS = new URLSearchParams({
      ...((filter["Data Inicial"] || filter["Data Final"]) && {
        dateFilter: `${filter["Data Inicial"] ? filter["Data Inicial"].toJSON() : null}|${filter["Data Final"] ? filter["Data Final"].toJSON() : null}`,
      }),
      ...(filter["Filtro"] && {
        filter: filter["Filtro"],
      }),
    });
    setfilterLoading(true);
    switch (filter["Tipo"]) {
      default:
      case "Turmas":
        // api.get(`/commercial/total-amount/report?${PARAMS}`, config)
        // .then(_commercials => {

        //   let __commercials = [..._commercials.data];

        //   let totalReceber = 0.00
        //   let totalRecebido = 0.00
        //   let totalGerado = 0.00
        //   let totalRecebidoManual = 0.00
        //   let totalRecebidoAuto = 0.00
        //   let totalRecebidoJuros = 0.00

        //   if(__commercials.length > 0){
        //     __commercials.forEach(__commercial => {
        //       totalRecebido = parseFloat(totalRecebido) + parseFloat(__commercial.totalRecebido)
        //       totalGerado = parseFloat(totalGerado) + parseFloat(__commercial.totalGerado)
        //       totalRecebidoManual = parseFloat(totalRecebidoManual) + parseFloat(__commercial.totalRecebidoManual)
        //       totalRecebidoAuto = parseFloat(totalRecebidoAuto) + parseFloat(__commercial.totalRecebidoAuto)
        //       totalReceber = parseFloat(totalReceber) + parseFloat(__commercial.aReceber ? __commercial.aReceber : 0)
        //       totalRecebidoJuros = parseFloat(totalRecebidoJuros) + parseFloat(__commercial.totalRecebidoJuros)
        //     })
        //   }

        //   setReports({
        //     data: [
        //       { label: "Pago", value: totalRecebido },
        //       { label: "A receber", value: totalReceber }
        //     ],
        //     title: "Financeiro Geral",
        //     type: "a receber",
        //     table: __commercials,
        //     extra: {
        //       totalReceber: totalReceber,
        //       totalRecebido: totalRecebido,
        //       totalGerado: totalGerado,
        //       totalRecebidoManual: totalRecebidoManual,
        //       totalRecebidoAuto: totalRecebidoAuto,
        //       totalRecebidoJuros: totalRecebidoJuros
        //     }
        //   })
        setfilterLoading(false);

        // })
        break;
      case "Inadimplência":
        api
          .get(
            `/commercial/inadimplencia/report?id=${filter["Turma"] && filter["Turma"].value ? filter["Turma"].value : null}`,
            config,
          )
          .then(_commercials => {
            let __commercials = [..._commercials.data];

            let valorBruto = 0.0;
            let valorJuros = 0.0;
            let valorTotal = 0.0;

            if (__commercials.length > 0) {
              __commercials.forEach(__commercial => {
                valorBruto = parseFloat(valorBruto) + parseFloat(__commercial.valorBruto);
                valorJuros = parseFloat(valorJuros) + parseFloat(__commercial.valorJuros);
                valorTotal = parseFloat(valorTotal) + parseFloat(__commercial.valorTotal);
              });
            }

            setReports({
              data: [
                { label: "Valor total", value: valorTotal },
                { label: "Juros", value: valorJuros },
              ],
              title: "Relatorio de inadimplência",
              type: "a receber",
              table: __commercials,
              extra: {
                valorBruto: valorBruto,
                valorJuros: valorJuros,
                valorTotal: valorTotal,
              },
            });
            setfilterLoading(false);
          });
        break;
    }
  }, [filter]);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, []);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <Content>
          {/* <Row>
            <Col>
              <ComposedChart
                style={{ width: "100%", height: "100%", maxHeight: "70vh", aspectRatio: 1.618 }}
                responsive
                data={data}
                margin={{
                  top: 5,
                  right: 0,
                  left: 0,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis width="auto" />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="Total Esperado" stroke="#8884d8" />
                <Area type="monotone" dataKey="Total Vigente" stroke="#82ca9d" fill="red" />
                <Area type="monotone" dataKey="Total Recebido" stroke="#c21e1e" />
              </ComposedChart>
            </Col>
          </Row> */}
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <h2 className="page-title">Relatórios Financeiro</h2>
                <div className="d-flex ml-4">
                  <PrintPage.PrintButton label="Gerar PDF" />
                  <PrintPage.CSVButton
                    label="Gerar CSV"
                    title={reports.title}
                    overview={reports.data}
                    table={reports?.table?.flatMap(_row => {
                      const baseRow = {
                        ...(_row.label !== undefined && { Turma: _row.label }),
                        ...(_row["Curso"] !== undefined && { Curso: _row["Curso"] }),
                        ...(_row["Período"] !== undefined && { Período: _row["Período"] }),
                        ...(_row["Status"] !== undefined && { Status: _row["Status"] }),
                      };

                      // Verifica se há inadimplentes e adiciona linhas extras
                      if (Array.isArray(_row.inadimplentes) && _row.inadimplentes.length > 0) {
                        const subRows = _row.inadimplentes.map(i => ({
                          Turma: baseRow.Turma || "", // herdando nome da turma
                          Curso: baseRow.Curso || "",
                          Período: baseRow.Período || "",
                          Status: baseRow.Status || "",
                          Contrato: i.contract_number_legacy,
                          Nome: i.name,
                          Telefone: formatPhone(i.phone),
                          Celular: formatPhone(i.cell),
                          "Qtd. Boletos": i.boletos_vencidos,
                          "Valor Original": formatReal(i.valor_em_atraso),
                          "Valor Corrigido": formatReal(i.valor_com_juros),
                        }));

                        return [baseRow, ...subRows]; // retorna linha da turma + inadimplentes
                      }

                      return [baseRow]; // apenas linha da turma
                    })}
                    signed_by={me.username}
                    filter={filter}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-2 -hide-on-print" style={{ zIndex: 10, position: "relative" }}>
            <Col sm={3}>
              <span className="lince-input_label">Tipo de Resultados</span>
              <Slct
                className="w-100"
                placeholder="..."
                value={filter["Tipo"]}
                options={[
                  { label: "Geral", value: "Geral" },
                  { label: "Turma", value: "Turma" },
                  { label: "Inadimplência", value: "Inadimplência" },
                  { label: "Recebimentos Extras", value: "Recebimentos Extras" },
                ]}
                onChange={e => {
                  setFilter({
                    ...filter,
                    Tipo: e.value,
                  });
                }}
              />
            </Col>
            {(filter["Tipo"] === "Inadimplência" || filter["Tipo"] === "Turma") && (
              <Col sm={3}>
                <span className="lince-input_label">Turma</span>
                <Slct
                  className="w-100"
                  options={groups || []}
                  placeholder="..."
                  value={filter["Turma"]?.value}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      Turma: { value: e.value, label: e.label },
                    });
                  }}
                />
              </Col>
            )}
            {filter["Tipo"] === "Turma" && (
              <>
                <Col sm={3}>
                  <span className="lince-input_label">Status</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Status"]}
                    options={[
                      { label: "Todos", value: null },
                      { label: "Em aberto", value: "Geral" },
                      { label: "Em processamento", value: "nao-gerado" },
                      { label: "Cancelados", value: "cancelado" },
                      { label: "Atrasados", value: "atrasado" },
                      { label: "Pagos", value: "pago" },
                    ]}
                    onChange={e => {
                      setFilter({
                        ...filter,
                        Status: e.value,
                      });
                    }}
                  />
                </Col>
              </>
            )}
            {filter["Tipo"] === "Geral" && (
              <>
                <Col sm={3}>
                  <span className="lince-input_label">Filtrar por:</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Filtro"]}
                    options={[
                      { label: "Data de Vencimento", value: "dataVencimento" },
                      { label: "Data de Pagamento", value: "dataPagamento" },
                    ]}
                    onChange={e => {
                      setFilter({
                        ...filter,
                        Tipo: e.value,
                      });
                    }}
                  />
                </Col>
                <Col sm={3}>
                  <Form.Group>
                    <span className="lince-input_label">Data Inicial</span>
                    <DatePicker
                      canClear
                      selected={filter["Data Inicial"]}
                      changeDate={e => {
                        setFilter({
                          ...filter,
                          "Data Inicial": e,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={3}>
                  <Form.Group>
                    <span className="lince-input_label">Data Final</span>
                    <DatePicker
                      canClear
                      selected={filter["Data Final"]}
                      changeDate={e => {
                        setFilter({
                          ...filter,
                          "Data Final": e,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
          </Row>
          {filterLoading ? (
            <Loading className="mt-3" />
          ) : (
            <Row>
              <Col>
                <ChartsBar reports={reports.data} title={reports.title} type={reports.type} format_value="real" />
                {reports.table && filter["Tipo"] !== "Turma" && (
                  <Table className={`${tableStyle.table} mt-4`}>
                    {filter["Tipo"] === "Geral" && (
                      <thead>
                        <tr>
                          <>
                            <th>Turma</th>
                            <th>A pagar</th>
                            <th>Pagamentos Gerados</th>
                            <th>Recebido</th>
                            <th>Baixa Automatica</th>
                            <th>Baixa Manual</th>
                            <th>Juros Recebidos</th>
                          </>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {reports.table.map((e, index) => (
                        <React.Fragment key={index}>
                          {filter["Tipo"] === "Inadimplência" && (
                            <tr>
                              <th>Turma</th>
                              <th>Valores Atrasados</th>
                              <th>Juros</th>
                              <th>Valores Atrasados + Juros</th>
                            </tr>
                          )}
                          <tr>
                            <td>
                              {e.institution ? e.course.title : ""} {e.year}.{e.period} (
                              {e.institution ? e.institution.title : ""}){" "}
                              {e.contract_number_legacy ? `(${e.contract_number_legacy})` : ""}
                            </td>
                            {filter["Tipo"] === "Geral" && (
                              <>
                                <td>{formatReal(e.aReceber || 0)}</td>
                                <td>{formatReal(e.totalGerado)}</td>
                                <td>{formatReal(e.totalRecebido)}</td>
                                <td>{formatReal(e.totalRecebidoAuto)}</td>
                                <td>{formatReal(e.totalRecebidoManual)}</td>
                                <td>{formatReal(e.totalRecebidoJuros)}</td>
                              </>
                            )}
                            {filter["Tipo"] === "Inadimplência" && (
                              <>
                                <td>{formatReal(e.valorBruto)}</td>
                                <td>{formatReal(e.valorJuros)}</td>
                                <td>{formatReal(e.valorTotal)}</td>
                              </>
                            )}
                          </tr>

                          {/* Verifica se há inadimplentes para exibir nova tabela abaixo */}
                          {filter["Tipo"] === "Inadimplência" &&
                            e.inadimplentes &&
                            e.inadimplentes.length > 0 &&
                            !trainees && (
                              <tr>
                                <td colSpan={7}>
                                  <Table bordered size="sm" className="mt-2">
                                    <thead>
                                      <tr>
                                        <th>Contrato</th>
                                        <th>Nome</th>
                                        <th>Telefone</th>
                                        <th>Celular</th>
                                        <th>Qtd Boletos</th>
                                        <th>Valor Original</th>
                                        <th>Valor Corrigido</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {e.inadimplentes.map((inad, i) => (
                                        <tr key={i}>
                                          <td>{inad.contract_number_legacy}</td>
                                          <td>{inad.name}</td>
                                          <td>{formatPhone(inad.phone)}</td>
                                          <td>{formatPhone(inad.cell)}</td>
                                          <td>{inad.boletos_vencidos}</td>
                                          <td>{formatReal(inad.valor_em_atraso)}</td>
                                          <td>{formatReal(inad.valor_com_juros)}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            )}
                        </React.Fragment>
                      ))}

                      {filter["Tipo"] === "Geral" && (
                        <tr>
                          <td>
                            <b>Total: {reports.table.length}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.totalReceber)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.totalGerado)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.totalRecebido)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.totalRecebidoAuto)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.totalRecebidoManual)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.totalRecebidoJuros)}</b>
                          </td>
                        </tr>
                      )}
                      {filter["Tipo"] === "Inadimplência" && (
                        <tr>
                          <td>
                            <b>Total: {reports.table.length}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.valorBruto)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.valorJuros)}</b>
                          </td>
                          <td>
                            <b>{formatReal(reports.extra.valorTotal)}</b>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
                {trainees && trainees.length > 0 && filter["Tipo"] === "Inadimplência" && (
                  <Table className={`${tableStyle.table} mt-4`}>
                    <thead>
                      <tr>
                        <th>Formando</th>
                        <th>Valores Atrasados</th>
                        <th>Juros</th>
                        <th>Valores Atrasados + Juros</th>
                        <th>Boletos Atrasados</th>
                      </tr>
                    </thead>
                    <tbody>
                      {trainees.map(e => (
                        <tr>
                          <td>{e.name}</td>
                          <td>{formatReal(e.valorBruto)}</td>
                          <td>{formatReal(e.valorJuros)}</td>
                          <td>{formatReal(e.valorTotal)}</td>
                          <td>{e.totalBoletos}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}

                {payments && payments.length > 0 && filter["Tipo"] === "Turma" && (
                  <Table className={`${tableStyle.table} mt-4`}>
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Formando</th>
                        <th>Status</th>
                        <th>Valor</th>
                        <th>a pagar/pago</th>
                        <th>vencimento</th>
                        <th>Data do pagamento</th>
                        <th>parcela</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments.map(e => (
                        <tr>
                          <td>{e.id}</td>
                          <td>{e.trainee.name}</td>
                          <td>
                            <StatusFlag status={statusPaymentSlips(e.status)} />
                          </td>
                          <td>{formatReal(e.value)}</td>
                          <td>{formatReal(e.value_paid)}</td>
                          <td>{formatDate(e.due_date, 2)}</td>
                          <td>{formatDate(e.payment_date, 2)}</td>
                          <td>
                            {e.quotas}/{e.total_quotas}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Col>
              {filter["Tipo"] === "Turma" ? (
                <Row>
                  <Col sm={{ span: 4, offset: 8 }}>
                    <div className="row-calc-bg">
                      <span>Total a pagar</span> <span>R$ {totalPayments.pagar.toFixed(2)}</span>
                    </div>
                  </Col>
                  <Col sm={{ span: 4, offset: 8 }}>
                    <div className="row-calc-bg">
                      <span>Total pago</span> <span>R$ {totalPayments.pago.toFixed(2)}</span>
                    </div>
                  </Col>
                  <Col sm={{ span: 4, offset: 8 }}>
                    <div className="row-calc-bg">
                      <span>Total juros</span> <span>R$ {totalPayments.juros.toFixed(2)}</span>
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Row>
          )}
        </Content>
      </Main>
    </PrintPage>
  );
}
